import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service'; 
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {

  private error = {
    hasError: false,
    errorMessage: ''
  };

	loginData = {
		email: "",
		password: ""
  }

  private username: string;
  private videoList: Array<any>;

  constructor(
    private userService:UserService,
    private router: Router
  ) { 
    document.body.style.backgroundColor = "#fff"
  }



  ngOnInit() {
  }

  loginUser():void{
    this.userService.login(this.loginData.email,this.loginData.password)
    .then((user)=>{
      console.log(user);
      localStorage.setItem('user',JSON.stringify(user));
      this.router.navigate(['videos']);
    },(error)=>{
      this.error.hasError = true;
      this.error.errorMessage = error;
    })
  } 
}



// WEBPACK FOOTER //
// ./src/app/guest/login-page/login-page.component.ts